// lib
import React, { useState, useMemo } from 'react'
import PropTypes from 'prop-types'

import { hasComments } from '@aytm/app/stats/page/components/lib/utils'
import { CUSTOM_QUESTION_REG } from '@aytm/app/stats/page/comments/lib/constants'

// components
import { Dropdown } from 'primereact/dropdown'

// styles
import style from '@aytm/app/stats/page/question-views/cn/styles/Controls.module.scss'

const valueExportTemplate = () => <i className="icon-aytmfd-export-v2" />

const ExportControls = ({ model, features, isSurveyGuest, onExport }) => {
  const { id, type, items } = model

  const [exporting, setExporting] = useState(false)

  const exportOptions = useMemo(() => {
    const options = []

    const allowed = ['oe', 'oex', 'cn'].includes(type) || null === items || hasComments(items)
    if (allowed && !features.oe_tags_management.disabled) {
      options.push({ key: 'csv-verbatim', text: 'Download all verbatim (CSV)' })
      if (!CUSTOM_QUESTION_REG.test(String(id).split('-')[0])) {
        options.push({ key: 'csv-verbatim-codes', text: 'Download all verbatim with codes (CSV) ' })
      }
    }

    return options
  }, [id, type, items, features.oe_tags_management.disabled])

  const onExportChange = event => {
    setExporting(true)

    onExport(event.value, () => setExporting(false))
  }

  return 0 < exportOptions.length && !isSurveyGuest ? (
    <div className="p-fluid p-field p-right">
      <div className={`${style.export} p-field`}>
        {exporting ? (
          <i className="icon-aytmfd-refresh-v2 aytmfd-spin" />
        ) : (
          <Dropdown
            className="p-dropdown-icon p-dropdown-right"
            placeholder=""
            options={exportOptions}
            optionValue="key"
            optionLabel="text"
            valueTemplate={valueExportTemplate}
            fixedDropdownDir="bottom"
            onChange={onExportChange}
          />
        )}
      </div>
    </div>
  ) : null
}

ExportControls.propTypes = {
  model: PropTypes.object,
  features: PropTypes.object,
  isSurveyGuest: PropTypes.bool,
  onExport: PropTypes.func
}

ExportControls.displayName = 'ExportControls'

export default ExportControls
